import { useLocation } from 'react-router-dom';
import { DateRangeKey } from '../../commonUI/DateRangeFilterSelect/utils/generateDateRangeFilter';

type LocationState = {
  dateRangeKey?: DateRangeKey;
  scanDate?: string;
};

export const useLocationState = (): LocationState => {
  const { state } = useLocation();
  return state ?? { dateRangeKey: undefined, scanDate: undefined };
};
